import React from "react";
import "./styles.scss";
import { Link } from "react-router-dom";
import Actions from "../../Actions";
import defaultAlbumImg from "../../../../../public/images/default-alblum-img.png";
import PlayButton from "../../../../shared/Svg/PlayButton";

export default ({ albumSetter, album, className, showActions }) => {
  const { user, id, title, preview_image } = album;
  return (
    <div className={`album-square-tag card ${className ? className : ""}`}>
      <Link
        to={`/${user?.slug}/albums/${id}`}
        className="card-body position-relative"
      >
        <img
          alt={title}
          src={preview_image ? preview_image.url : defaultAlbumImg}
        />
        <div className="position-absolute controls">
          <PlayButton className="play-button text-center"  />
        </div>
      </Link>
      {showActions && (
        <div className="card-footer">
          <Actions object={album} setObject={albumSetter} />
        </div>
      )}
    </div>
  );
};
